import client from '../ducks/storage-api-client'

export const upload = (files, onUploadProgress) => (
  client.upload(files, { onUploadProgress })
)
